import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Link,
  Theme,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
// import {
//   PlayCircleFilledWhiteIcon
// } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import './selections.css';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { Tenant } from '@ivymobi/orbit-core';


import _ from 'lodash';
import { filter, isUndefined, union, isEmpty, cloneDeep } from 'lodash';
import { Autoplay, Pagination, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { getArticles, getArticlesById, getEDMOperateAction, getFirstLevelIndustryCaseAction, getFunctionalAction, getHMIFunctionalAction, getIndustrialAction, getLMFunctionIntrolAction, getLMOperateAction, getSecondLevelIndustryCaseAction, getSVSolutionAction, getThirdLevelIndustryAction } from '@ivymobi/orbit-core/business/productCenter';
import { DeviceType, InnerUserContext, UserContext, WebSiteContext } from '../../orbit-context';
import Title from '../../components/views/title';
import { TabPanel } from '../../components';
import RichText from '../../components/richText/RichTextRenderer';
import { base64_decode, base64_encode } from '@ivymobi/orbit-core/business/user';
import fullTexts from '../fullTexts';
import { userShareEvent } from '@ivymobi/orbit-core/business/share';
const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'row',
  },
  appcaseContainer: {
    height:'100%',
    display:'flex',
    flexDirection:'column'
  },
  appcasePages: {
   
    display:'flex',
    flexDirection:'column',
    width:'100%',
    flexGrow:1,
    margin: '0 auto',
    marginTop: '20px',
  
    // minWidth: '1200px',
  },
  appcasewbg: {
    // backgroundColor: '#fff',
    height: '600px',
    marginTop: '15px',
    borderRadius: '2px',
    userSelect: 'none',
  },
  swiperItem: {
    position: 'relative',
  },
  swiperImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  swiperCover: {
    width: '100%',
    height: '200px',
    position: 'absolute',
    bottom:' 0',
    backgroundColor: 'rgba(15, 15, 15, .6)',
    cursor: 'pointer',
  },
}));
const CustomTab = withStyles((theme: Theme) =>  createStyles({
  root:{
    minWidth:'unset',
    minHeight:'unset',
  }
}))(Tab);
const CustomTabs = withStyles((theme: Theme) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    bottom:'4px',
    top:'unset',
    height:'2px',
    '& > span': {
      width: '100%',
      backgroundColor: 'red',
    },
  },
  flexContainer:{
    justifyContent: 'center',
    alignItems:'center',
    padding:'7px'
  }

}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const LMFunctionIntrolView = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const deviceType = useContext(DeviceType);
  const innerUser = useContext(InnerUserContext);
  const {user, token} = useContext(UserContext);

  const { webInfo } = useContext(WebSiteContext);
  let { secondId, thirdId } = useParams<any>();

  const [loading, setLoading] = useState(false);
  const [firstLevelCase, setFirstLevelCase] = useState([]);
  const [secondLevelCase, setSecondLevelCase] = useState([]);
  const [thirdLevelCase, setThirdLevelCase] = useState([]);
  // 路由列表数组
  const [extraBreadcrumbs, setExtraBreadcrumbs] = useState([]);
  // 路由标签对象
  const [breadList, setBreadList] = useState([]);
  // 当前页面层级
  const [pageLevel, setPageLevel] = useState('first');
  const [value,setValue] = useState(0);

  // webInfo有值后 获取全部一级数据
  useEffect(() => {
    if (isUndefined(webInfo))
      return;
    setLoading(true);

    const firstLevelImages = new Promise((resolve) => {
      resolve(dispatch(getArticles({user:{token:null, user:null}, tenant:{id:webInfo.tnt_id, secondId: secondId},id:'1229952d-0777-441e-b918-63cfc3ed802a'})));
    });
    firstLevelImages.then((res) => {
      let infos = []
      for(let i=0;i<res.data[0].children.length;i++){ 
        let item =res.data[0].children[i] 
        infos.push({id:item.id,title:item.a_name,mime:item.thumbnail})
      }
      setFirstLevelCase(infos);
      setLoading(false);
    }); 
  }, [webInfo]);
  // // 有二级ID 面包屑加一层，获取二级数据
  // useEffect(() => {

  //   if (isUndefined(secondId))
  //     setExtraBreadcrumbs([]);
  //   if (isUndefined(webInfo)|| isEmpty(firstLevelCase) || isUndefined(secondId))
  //     return;
  //   // 添加一级路由列表
  //   firstLevelCase.forEach((item) => {
  //     if (item.index == secondId) {
  //       const arr = [];
  //       item.url = '/inv/functional/' + secondId;
  //       arr.push(item);
  //       setExtraBreadcrumbs(arr);
  //     }
  //   });
  //   setLoading(true);
  //   setSecondLevelCase(firstLevelCase[secondId]?.tab);
  //   setLoading(false);
  // }, [webInfo, firstLevelCase, secondId]);
  // 有三级ID  面包屑再加一层， 获取三级数据
  useEffect(() => {

    if (isUndefined(thirdId) && extraBreadcrumbs.length > 1) {
      const breadList = cloneDeep(extraBreadcrumbs);
      setExtraBreadcrumbs(breadList.slice(0, 1));
      setThirdLevelCase(null);
    }
    if (isUndefined(webInfo)|| isEmpty(firstLevelCase) || isUndefined(secondId) || isUndefined(thirdId))
      return;
      firstLevelCase.forEach((item) => {
        if (item.id === thirdId) {
          const routerList = cloneDeep(extraBreadcrumbs);
          item.name= item.title
          routerList[1] = item;
          setExtraBreadcrumbs(routerList);
        }
      });
    // let indexs = thirdId.split('_');
    // // let thirdInfo  =  firstLevelCase[secondId].tab[indexs[0]].button[indexs[1]];
    // const routerList = cloneDeep(extraBreadcrumbs);
    // let item = {}
    // item.name = thirdId;
    // // item.url = '/inv/functional/' + secondId + '/' + thirdId;
    // routerList[1] = item;
    // setExtraBreadcrumbs(routerList);
    // secondLevelCase.forEach((item) => {
    //   console.log("item===",item,thirdInfo) 
    //   if (item.id === thirdId) { 

    //   }
    // });
    setLoading(true);
    const threeLevelCase = new Promise((resolve) => {
      resolve(dispatch(getArticlesById({user:{token:null, user:null}, tenant:{id: webInfo.tnt_id}, id: thirdId})));
    });
    threeLevelCase.then((res: string[]) => {
      setThirdLevelCase(res.data[0]);
      setLoading(false);
    });
    // setLoading(true);
    // const threeLevelCase = new Promise((resolve) => {
    //   resolve(dispatch(getThirdLevelIndustryAction({user:{token:null, user:null}, tenant:{id: webInfo.tnt_id}, thirdId: thirdId})));
    // });
    // threeLevelCase.then((res: string[]) => {
    //   setThirdLevelCase(res);
    //   setLoading(false);
    // });
  }, [webInfo, firstLevelCase, secondId, secondLevelCase, thirdId]);
  // 路由处理
  useEffect(() => {
    if (isEmpty(extraBreadcrumbs)){
      props.setTitle("功能介绍")
      props.setParents([{to:'/lm',name:'激光加工机'}])

      return setBreadList([]);
    }
    const breadList = extraBreadcrumbs.map((item, index) => {
      // const url = index
      if(isUndefined(item))
        return null;
      return (<Link 
        key={index}
        color='textPrimary'
        to={item?.url}
        component={RouteLink}
      >
        {item?.name}
      </Link>);
    });
    setBreadList(breadList);
  }, [extraBreadcrumbs]);
  // 路由层级
  useEffect(() => {
    const level = isUndefined(thirdId) ? (isUndefined(secondId) ? 'first' : 'second') : 'third';
    setPageLevel(level);
    if(thirdId)
      dispatch(userShareEvent({user:{user:{id:innerUser?.userId??user?.id}}, share:{tenantId:webInfo.tnt_id,id:'11111111-1111-1111-1111-111111111111',memberId:innerUser?.memberId}, document:{id:thirdId,type:'article'}, type:'view', detail:null}));

  }, [secondId, thirdId]);

  // console.log('--------extraBreadcrumbsextraBreadcrumbs');
  // console.log(extraBreadcrumbs);

  const getTwoLevel = (item) => {
    history.push(`/lm/functionintrol/${item.id}/${item.id}`);
  };
  const getThreeLevel = (id) => {
    history.push(`/lm/functionintrol/${secondId}/${id}`);
  };

  return (
    <div className={classes.appcaseContainer}>
      {deviceType==='computer'&&<Breadcrumbs style={{ height: '30px' }} separator=">" maxItems={8}>
        <Link
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
          color='textPrimary'
          to={'/lm'}
          component={RouteLink}
        >
          激光加工机
        </Link>
        <Link
          color='textPrimary'
          to={'/lm/functionintrol'}
          component={RouteLink}
        >
          功能介绍
        </Link>
        {breadList.map((item) => {
          return item;
        })}
        {/* {extraBreadcrumbs.map((item, index) => {
          console.log('执行路由遍历'+ index);
          // const url = index
          return (<Link 
            key={index}
            color='textPrimary'
            to={item.url}
            component={RouteLink}
          >
            {item.name}
          </Link>);
        })} */}
      </Breadcrumbs>}
      {/* 第一级 */}
      {pageLevel === 'first' && <Box className={classes.appcasePages}>
      <Grid container spacing={3} className='cardGrid'>
          {firstLevelCase.map((item, index) => {
            return (
              <Grid item xs={6} md={4} lg={3} key={index}>
                <Card onClick={() => getTwoLevel(item)} className='cardImage'>
                  <CardMedia
                    className='cardMedia'
                    image={item.mime}
                  />
                  <CardContent className='cardContent'>
                    <Typography>{item.title}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>

      </Box>}

      {/* 第三级 */}
      {pageLevel === 'third' &&  <Box className={classes.appcasePages} style={{ background:'white',padding:'20px',width:deviceType==='computer'?'80%':'100%',maxWidth:'1000px'}}>
        {extraBreadcrumbs.map((item, index) => {
          // if (item.id === thirdId) {
          //   return (
          //     <Title name={item.name} key={index} ></Title>
          //   );
          // }
        })}
       <Box style={{display:'flex',justifyContent:'center'}}>
        <div style={{width:'100%',overflow:'auto'}} dangerouslySetInnerHTML={{__html:thirdLevelCase?.info}}></div>

        </Box>
      </Box>}
      {loading && <CircularProgress size={30} />}
    </div>
  );
};

export default function LMFunctionIntrolContainer(props) {
  return (<LMFunctionIntrolView {...props} />);
}